import { Autocomplete, Box, Button, CircularProgress, Grid, TextField } from '@mui/material';
import { Form, Formik } from 'formik';
import React, { memo, useEffect, useState } from 'react';
import Textfield from '../../components/input/Textfield';
import * as Yup from 'yup';
import { apiRequest } from '../../utils/api';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { fetchCustomerData } from '../../redux/slices/customerSlice';
import { fetchRepsData } from '../../redux/slices/repSlice';

const AddNew = ({ onClose }) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);

    const { data: reps, isLoading: isLoadingReps, error: errorReps } = useSelector((state) => state.rep);
    const [selectedRep, setSelectedRep] = React.useState(null);

    useEffect(() => {
        if (!reps) {
            dispatch(fetchRepsData());
        }

        return () => {
            setSelectedRep(null);
        };
    }, []);

    const INITIAL_FORM_STATE = {
        name: '',
        email: '',
        phoneNo: '',
        phoneNo2: '',
        address: ''
    };

    const FORM_VALIDATION = Yup.object().shape({
        name: Yup.string().trim().required('Required'),
        email: Yup.string().email('Invalid email'),
        phoneNo: Yup.number()
            .typeError('Phone must be a number'),
            // .required('Required'),
            // .test('length', 'Input must be exactly 12 characters', (value) => value && value.toString().length === 12),
        phoneNo2: Yup.number()
            .typeError('Phone must be a number')
            .nullable(),
        address: Yup.string()
    });

    const handleSubmit = async (values) => {
        try {
            if (selectedRep == null) {
                return toast.error('Please select rep');
            }

            const resp = await apiRequest('post', 'customers', { ...values, user: selectedRep });

            if (resp?.data) {
                onClose();
                dispatch(fetchCustomerData());
            }
        } catch (error) {
            toast.error(error?.response?.data?.message ?? error?.response?.data ?? error?.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Formik
                initialValues={{
                    ...INITIAL_FORM_STATE
                }}
                validationSchema={FORM_VALIDATION}
                onSubmit={(values, { resetForm }) => {
                    setLoading(true);
                    handleSubmit(values, resetForm);
                }}
            >
                <Form>
                    <Grid container direction="row" spacing={2}>
                        <Grid item lg={6} md={6} sm={3.5} xs={12}>
                            <Textfield name="name" label="Name" />
                        </Grid>

                        <Grid item lg={6} sm={5} md={3} xs={12}>
                            {isLoadingReps ? (
                                <CircularProgress size={20} color="inherit" />
                            ) : (
                                <Autocomplete
                                    options={reps ?? []}
                                    getOptionLabel={(rep) => `${rep?.firstName} ${rep?.lastName} - ${rep?.phoneNo}`}
                                    value={reps?.find((i) => i?.id == selectedRep)}
                                    onChange={(event, selected) => {
                                        setSelectedRep(selected?.id || null);
                                    }}
                                    renderInput={(params) => <TextField {...params} label="Rep" variant="standard" />}
                                />
                            )}
                        </Grid>

                        <Grid item lg={4} md={4} sm={4} xs={12}>
                            <Textfield name="phoneNo" label="Phone Number" />
                        </Grid>

                        <Grid item lg={4} md={4} sm={4} xs={12}>
                            <Textfield name="phoneNo2" label="Phone Number 2 (Optional)" />
                        </Grid>

                        <Grid item lg={4} md={4} sm={4} xs={12}>
                            <Textfield name="email" label="Email" />
                        </Grid>

                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Textfield name="address" label="Address" />
                        </Grid>
                    </Grid>

                    <Box sx={styles.btnContainer}>
                        {loading ? (
                            <CircularProgress size={25} color="inherit" />
                        ) : (
                            <>
                                {/* -------------- onClick will call the onClose function that closes the History Modal */}
                                <Button onClick={onClose} variant="text" sx={{ color: 'red' }}>
                                    Cancel
                                </Button>

                                {/* -----------  change button title on the basis of history status */}
                                <Button type="submit" variant="text">
                                    Save
                                </Button>
                            </>
                        )}
                    </Box>
                </Form>
            </Formik>
        </div>
    );
}

export default memo(AddNew)

const styles = {
    loadingContainer: {
        height: 400,
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    btnContainer: {
        display: 'flex',
        direction: 'row',
        gap: 1,
        marginTop: 1,
        justifyContent: 'flex-end'
    }
};
